export default __webpack_public_path__ + "static/media/asmt-step1.9fe036b6.gif";